/// <amd-module name="VSSUI/Components/Dynamic/DynamicText" />

import * as React from "react";
import { IDynamicTextProps } from "../../Components/Dynamic/DynamicText.Props";
import { UncheckedObserver } from "VSSUI/Observer";
import { getNativeProps, htmlElementProperties } from "OfficeFabric/Utilities";

/** @deprecated */
export class DynamicText extends React.Component<IDynamicTextProps> {
    public render(): JSX.Element {
        let spanProps = { ...this.props } as IDynamicTextInternalProps;
        return (
            <UncheckedObserver {...spanProps} text={this.props.text}>
                <DynamicTextInternal text="" />
            </UncheckedObserver>
        );
    }
}

interface IDynamicTextInternalProps {
    text: string;
}

class DynamicTextInternal extends React.Component<IDynamicTextInternalProps> {
    public render(): JSX.Element {
        const spanProps = getNativeProps(this.props, htmlElementProperties);
        return <span {...spanProps}>{this.props.text}</span>;
    }
}
